import { SERVER_API_URL } from "../app.constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class WorkgroupService {
    private resourceUrl = SERVER_API_URL + 'api/workgroups';

    constructor(
        private http: HttpClient) {
    }

    getWorkgroups(includeInactive = false): Observable<HttpResponse<Nema.Crew.Model.WorkGroup[]>> {
        return this.http
            .get<Nema.Crew.Model.WorkGroup[]>(`${this.resourceUrl}?includeInactive=${includeInactive}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.WorkGroup[]>) => this.convertArrayResponse(res));
    }

    //private _convertResponse(res: HttpResponse<WorkgroupDto>): HttpResponse<WorkgroupDto> {
    //    const body: WorkgroupDto = this.convertItemFromServer(res.body);
    //    return res.clone({ body });
    //}

    private convertArrayResponse(res: HttpResponse<Nema.Crew.Model.WorkGroup[]>): HttpResponse<Nema.Crew.Model.WorkGroup[]> {
        const jsonResponse: Nema.Crew.Model.WorkGroup[] = res.body;
        const body: Nema.Crew.Model.WorkGroup[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer(workgroup: Nema.Crew.Model.WorkGroup): Nema.Crew.Model.WorkGroup {
        const copy: Nema.Crew.Model.WorkGroup = Object.assign({}, workgroup);
        return copy;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/workgroup.service.ts